import React, {useMemo} from 'react';
import {
    CustomFieldContainerSessionInfo,
    CustomFieldItemSessionInfo,
    FlexColumnSection,
    FlexSection,
    SmallText
} from "../../../styles/globalStyles";
import {getCourseInfoArray, sortCourseEventDays} from "../../../helpers/functions";
import CourseAgeRestrictionDisplay from "../../../components/CourseAgeRestrictionDisplay";
import {Colors} from "@arboxappv4/shared/src/styles/Colors";
import useScreenSize from "../../../helpers/hooks/useScreenSize";
import dayjs from "dayjs";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {useSelector} from "react-redux";
import {t} from "i18next";
import CustomFieldsDataDisplay from "../../../components/CustomFieldsDataDisplay";
import {DB_TIME_FORMAT} from "@arboxappv4/shared/src/constants/constants";

const CourseDescription = (props) => {
    const { course } = props;
    const globalLocation = useSelector(state => state.site.selectedLocation)
    const {isMobile} = useScreenSize()

    let days = useMemo(() => course ? sortCourseEventDays(course.series_events) : [], [course])
    let info = useMemo(() => course ? getCourseInfoArray(course, false, false) :  {}, [course])

    if(!course || !globalLocation) return <></>

    return (
        <FlexColumnSection gap={'20px'}>
            <div>
                <SmallText weight={'bold'}>{t('course-name')}: </SmallText>
                <div>{course.series_name}</div>
            </div>
            {Object.values(info).length > 0 &&
            <FlexSection gap={isMobile ? '8px' : '15px'} flex={'unset'} mobile={isMobile}>
                {Object.values(info).map((comp,i) => (
                    <FlexSection gap={isMobile ? '8px' : '15px'} flex={'unset'} mobile={isMobile}>
                        {!isMobile && i > 0 && <FontAwesomeIcon icon={solid('circle-small')} color={Colors.siteBlack} className={'dot-icon'}/>}
                        {comp}
                    </FlexSection>
                ))}
            </FlexSection>}
            <CustomFieldsDataDisplay data={course} wideContainer/>
            <CourseAgeRestrictionDisplay course={course} />
            {course.box_categories.bio &&
                <div>
                    <SmallText weight={'bold'}>{t('description')}: </SmallText>
                    <div style={{flex: 1, whiteSpace: 'pre-wrap'}}>{course.box_categories.bio}</div>
                </div>
            }
            {(course.live_link && course.live_link !== '') && <div>{t('online-course')}</div>}
            <FlexColumnSection flex={'unset'}>
                <SmallText weight={'bold'}>{t('course-days-header')}</SmallText>
                {days.map(day => <div>{t(`day-${day.day_of_week}`)}: {dayjs(day.start, DB_TIME_FORMAT).format(globalLocation.time_format)} - {dayjs(day.end, DB_TIME_FORMAT).format(globalLocation.time_format)}{day.description ? ` - ${day.description}` : ''}</div>)}
                {(course.allow_mid_booking && course.past) ? <div>{t('hug-started-expand-label')}</div> : null}
            </FlexColumnSection>
        </FlexColumnSection>
    );
};

export default CourseDescription;